export function logNewRelic(message: string, data: any, level: 'info' | 'error' = 'error') {
  if (typeof window !== 'undefined' && 'newrelic' in window) {
    (window.newrelic as any).log(message, {
      level,
      customAttributes: data,
    })
  }
}
